'use strict'

module.exports = something => something && typeof something.then === 'function'



// WEBPACK FOOTER //
// ../node_modules/dbsm-common/src/isPromise.js